import { Enums } from '@bode-canada/core';
import ServerlessApiService from '../ServerlessApiService';
import { FullListingDto } from '@/types/new-listing';

const { NewListingsApiPathEnum, ServerlessApiPathEnum } = Enums;

export default class NewListingApiService {
  static BASE_URL = `/${NewListingsApiPathEnum.NEW_LISTINGS}/${ServerlessApiPathEnum.V1}`;

  static deleteSoldListing(listingId: number): Promise<void> {
    return ServerlessApiService.delete(`${this.BASE_URL}/${listingId}`);
  }

  static deleteDraftListing(listingId: number): Promise<void> {
    return ServerlessApiService.delete(
      `${this.BASE_URL}/${Enums.NewListingsApiPathEnum.CUSTOMER}/${listingId}`,
    );
  }

  static getById(listingId: number): Promise<FullListingDto> {
    return ServerlessApiService.get(`${this.BASE_URL}/${listingId}`);
  }

  static getMLSListingOriginByCityAndProvince(
    city: string,
    province: Enums.ProvinceEnum,
  ): Promise<Enums.ListingOriginEnum> {
    return ServerlessApiService.get(`${this.BASE_URL}/search/address?city=${city}&province=${province}`);
  }
}
